/* Dormiva — interacciones propias. Sin librerias externas. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function yaHecho(el, clave) {
    var k = 'data-dv-' + clave;
    if (el.getAttribute(k) === '1') return true;
    el.setAttribute(k, '1');
    return false;
  }

  function initReveals() {
    var els = document.querySelectorAll('.dv-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dv-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dv-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initEstrellas() {
    var cajas = document.querySelectorAll('[data-dv-estrellas]');
    if (!cajas.length) return;
    cajas.forEach(function (caja) {
      if (yaHecho(caja, 'estrellas-listo')) return;
      var n = parseInt(caja.getAttribute('data-dv-estrellas'), 10) || 40;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.className = 'dv-hero__estrella';
        s.style.left = (Math.random() * 100).toFixed(2) + '%';
        s.style.top = (Math.random() * 100).toFixed(2) + '%';
        s.style.animationDelay = (Math.random() * 4).toFixed(2) + 's';
        var t = (Math.random() * 2 + 1).toFixed(1);
        s.style.width = t + 'px'; s.style.height = t + 'px';
        frag.appendChild(s);
      }
      caja.appendChild(frag);
    });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-dv-contador]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-dv-contador') + (n.getAttribute('data-dv-sufijo') || ''); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        var fin = parseFloat(el.getAttribute('data-dv-contador')) || 0;
        var suf = el.getAttribute('data-dv-sufijo') || '';
        var pre = el.getAttribute('data-dv-prefijo') || '';
        var dur = 1400, t0 = null;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var val = Math.round(fin * (1 - Math.pow(1 - p, 3)));
          el.textContent = pre + val + suf;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.dv-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      if (yaHecho(item, 'faq-listo')) return;
      var btn = item.querySelector('.dv-faq__boton');
      var panel = item.querySelector('.dv-faq__panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('dv-abierto');
        var grupo = item.closest('.dv-faq');
        if (grupo && grupo.getAttribute('data-dv-solo-uno') === 'true') {
          grupo.querySelectorAll('.dv-faq__item.dv-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('dv-abierto');
            otro.querySelector('.dv-faq__panel').style.height = '0px';
            otro.querySelector('.dv-faq__boton').setAttribute('aria-expanded', 'false');
          });
        }
        if (abierto) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
          item.classList.remove('dv-abierto');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('dv-abierto');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.height = panel.scrollHeight + 'px';
          window.setTimeout(function () {
            if (item.classList.contains('dv-abierto')) panel.style.height = 'auto';
          }, 450);
        }
      });
    });
  }

  function initGaleria() {
    var galerias = document.querySelectorAll('[data-dv-galeria]');
    if (!galerias.length) return;
    galerias.forEach(function (g) {
      if (yaHecho(g, 'galeria-listo')) return;
      var principal = g.querySelector('[data-dv-galeria-principal]');
      if (!principal) return;
      g.querySelectorAll('[data-dv-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-dv-src');
          var alt = btn.getAttribute('data-dv-alt') || '';
          if (!src) return;
          principal.style.opacity = '0';
          window.setTimeout(function () {
            principal.src = src;
            principal.alt = alt;
            principal.style.opacity = '1';
          }, 140);
          g.querySelectorAll('[data-dv-mini]').forEach(function (b) { b.classList.remove('dv-activa'); });
          btn.classList.add('dv-activa');
        });
      });
    });
  }

  function initVariantes() {
    var formas = document.querySelectorAll('[data-dv-producto]');
    if (!formas.length) return;
    formas.forEach(function (raiz) {
      if (yaHecho(raiz, 'variantes-listo')) return;
      var datos = raiz.querySelector('[data-dv-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var selects = raiz.querySelectorAll('[data-dv-opcion]');
      if (!selects.length) return;
      var input = raiz.querySelector('[data-dv-id-variante]');
      var precio = raiz.querySelector('[data-dv-precio]');
      var precioAnt = raiz.querySelector('[data-dv-precio-antiguo]');
      var boton = raiz.querySelector('[data-dv-anadir]');
      var textoBoton = boton ? boton.getAttribute('data-dv-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-dv-texto-agotado') : '';

      function formatea(cent) {
        var s = raiz.getAttribute('data-dv-formato') || '{{amount}}';
        var n = (cent / 100).toFixed(2);
        return s.replace('{{amount}}', n).replace('{{amount_no_decimals}}', Math.round(cent / 100));
      }
      function actualiza() {
        var elegidas = [];
        selects.forEach(function (s) { elegidas.push(s.value); });
        var v = variantes.filter(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        })[0];
        if (!v) return;
        if (input) input.value = v.id;
        if (precio) precio.textContent = formatea(v.price);
        if (precioAnt) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            precioAnt.textContent = formatea(v.compare_at_price);
            precioAnt.style.display = '';
          } else { precioAnt.style.display = 'none'; }
        }
        if (boton) {
          if (v.available) {
            boton.disabled = false; boton.classList.remove('dv-agotado');
            boton.textContent = textoBoton;
          } else {
            boton.disabled = true; boton.classList.add('dv-agotado');
            boton.textContent = textoAgotado;
          }
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', actualiza); });
    });
  }


  function initPacks() {
    var cajas = document.querySelectorAll('[data-dv-ofertas]');
    if (!cajas.length) return;
    cajas.forEach(function (caja) {
      if (yaHecho(caja, 'packs-listo')) return;
      var raiz = caja.closest('[data-dv-producto]');
      if (!raiz) return;
      var input = raiz.querySelector('[data-dv-id-variante]');
      var precio = raiz.querySelector('[data-dv-precio]');
      var antes = raiz.querySelector('[data-dv-precio-antiguo]');
      var ahorro = raiz.querySelector('[data-dv-ahorro]');
      var unidades = raiz.querySelector('[data-dv-unidades]');
      var soloElegido = caja.getAttribute('data-dv-abrir-elegido') !== 'false';
      function pinta(r) {
        if (unidades) unidades.value = r.getAttribute('data-dv-u') || '1';
        caja.querySelectorAll('[data-dv-caja]').forEach(function (l) {
          l.classList.remove('dv-elegida');
          if (soloElegido) {
            l.classList.remove('dv-abierta');
            var f = l.querySelector('[data-dv-flecha]');
            if (f) f.setAttribute('aria-expanded', 'false');
          }
        });
        var tarjeta = r.closest('[data-dv-caja]');
        if (tarjeta) {
          tarjeta.classList.add('dv-elegida');
          if (soloElegido) {
            tarjeta.classList.add('dv-abierta');
            var fl = tarjeta.querySelector('[data-dv-flecha]');
            if (fl) fl.setAttribute('aria-expanded', 'true');
          }
        }
        if (input) input.value = r.value;
        if (precio) precio.textContent = r.getAttribute('data-dv-p') || precio.textContent;
        if (antes) {
          var a = r.getAttribute('data-dv-a');
          antes.innerHTML = a || '';
          antes.style.display = a ? '' : 'none';
        }
        if (ahorro) {
          var d = r.getAttribute('data-dv-d');
          ahorro.textContent = d || '';
          ahorro.style.display = d ? '' : 'none';
        }
      }
      caja.querySelectorAll('[data-dv-pack]').forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) pinta(r); });
        if (r.checked) pinta(r);
      });
      caja.querySelectorAll('[data-dv-flecha]').forEach(function (f) {
        f.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var tarjeta = f.closest('[data-dv-caja]');
          if (!tarjeta) return;
          var abierta = tarjeta.classList.toggle('dv-abierta');
          f.setAttribute('aria-expanded', abierta ? 'true' : 'false');
        });
      });
    });
  }


  function initExtras() {
    var cajas = document.querySelectorAll('[data-dv-extras]');
    if (!cajas.length) return;
    cajas.forEach(function (caja) {
      if (yaHecho(caja, 'extras-listo')) return;
      var raiz = caja.closest('[data-dv-producto]');
      if (!raiz) return;
      var form = raiz.querySelector('form[action*="/cart/add"]');
      var filas = [].slice.call(caja.querySelectorAll('[data-dv-extra]'));

      function elegidos() {
        return filas.filter(function (f) {
          return f.classList.contains('dv-elegido') && !f.classList.contains('dv-oculto');
        });
      }
      function pinta() {
        if (!form) return;
        if (elegidos().length) form.classList.add('dv-con-extras');
        else form.classList.remove('dv-con-extras');
      }
      filas.forEach(function (f) {
        var boton = f.querySelector('.dv-extra__mas');
        function alterna(e) {
          if (e) e.preventDefault();
          f.classList.toggle('dv-elegido');
          if (boton) boton.setAttribute('aria-pressed', f.classList.contains('dv-elegido') ? 'true' : 'false');
          pinta();
        }
        f.addEventListener('click', alterna);
        if (boton) boton.addEventListener('click', function (e) { e.stopPropagation(); alterna(e); });
      });

      // mostrar solo los extras de la opcion elegida
      function filtra(indice) {
        filas.forEach(function (f) {
          var solo = parseInt(f.getAttribute('data-dv-opcion'), 10) || 0;
          var oculto = solo !== 0 && solo !== indice;
          f.classList.toggle('dv-oculto', oculto);
          if (oculto) f.classList.remove('dv-elegido');
        });
        pinta();
      }
      var radios = [].slice.call(raiz.querySelectorAll('[data-dv-pack]'));
      radios.forEach(function (r, i) {
        r.addEventListener('change', function () { if (r.checked) filtra(i + 1); });
        if (r.checked) filtra(i + 1);
      });
      if (!radios.length) filtra(0);

      if (form) {
        form.addEventListener('submit', function (e) {
          var extra = elegidos();
          if (!extra.length) return;
          e.preventDefault();
          var boton = form.querySelector('[data-dv-anadir]');
          if (boton) { boton.disabled = true; boton.textContent = boton.getAttribute('data-dv-texto-cargando') || 'Añadiendo…'; }
          var idPrincipal = form.querySelector('[name=id]').value;
          var cant = form.querySelector('[name=quantity]');
          var propiedades = {};
          form.querySelectorAll('input[name^="properties["]').forEach(function (p) {
            var clave = p.getAttribute('name').replace('properties[', '').replace(']', '');
            if (p.value) propiedades[clave] = p.value;
          });
          var items = [{ id: Number(idPrincipal), quantity: cant ? (parseInt(cant.value, 10) || 1) : 1, properties: propiedades }];
          extra.forEach(function (f) {
            items.push({ id: Number(f.getAttribute('data-dv-variante')), quantity: 1 });
          });
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { window.location.href = '/cart'; })
            .catch(function () { form.submit(); });
        });
      }
    });
  }

  function initCantidad() {
    document.querySelectorAll('.dv-cantidad').forEach(function (caja) {
      if (yaHecho(caja, 'cantidad-listo')) return;
      var input = caja.querySelector('input');
      if (!input) return;
      caja.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var paso = b.getAttribute('data-dv-paso') === 'mas' ? 1 : -1;
          var v = parseInt(input.value, 10) || 1;
          var tope = parseInt(input.getAttribute('max'), 10) || 99;
          input.value = Math.min(tope, Math.max(1, v + paso));
        });
      });
    });
  }

  function initBarra() {
    var barras = document.querySelectorAll('[data-dv-barra]');
    if (!barras.length) return;
    [].slice.call(barras).forEach(function (barra) {
      if (barra.getAttribute('data-dv-listo') === '1') return;
      barra.setAttribute('data-dv-listo', '1');

      var envoltorio = barra.closest('.shopify-section') || document;
      var raiz = envoltorio.querySelector('[data-dv-producto]');
      var form = envoltorio.querySelector('form[action*="/cart/add"]');
      var principal = envoltorio.querySelector('[data-dv-anadir]');
      var boton = barra.querySelector('[data-dv-barra-btn]');
      var pack = barra.querySelector('[data-dv-barra-pack]');
      var precio = barra.querySelector('[data-dv-barra-precio]');
      var antes = barra.querySelector('[data-dv-barra-antes]');

      barra.removeAttribute('hidden');

      // sigue al selector de packs
      if (raiz) {
        [].slice.call(raiz.querySelectorAll('[data-dv-pack]')).forEach(function (r) {
          function copia() {
            if (!r.checked) return;
            var t = r.getAttribute('data-dv-titulo');
            if (pack && t) pack.textContent = t;
            if (precio) precio.textContent = r.getAttribute('data-dv-p') || precio.textContent;
            if (antes) {
              var a = r.getAttribute('data-dv-a');
              antes.innerHTML = a || '';
              if (a) antes.removeAttribute('hidden'); else antes.setAttribute('hidden', '');
            }
          }
          r.addEventListener('change', copia);
          copia();
        });
      }

      // Los controles de la barra no duplican logica: pulsan el radio real de la
      // ficha y dejan que initPacks / initColores hagan su trabajo.
      function proxy(selBoton, selRadio, atributo) {
        var botones = [].slice.call(barra.querySelectorAll(selBoton));
        if (!botones.length || !raiz) return;
        function marca() {
          var activo = raiz.querySelector(selRadio + ':checked');
          var val = activo ? activo.getAttribute(atributo) : null;
          botones.forEach(function (b) {
            b.classList.toggle('dv-activo', b.getAttribute('data-dv-val') === val);
          });
        }
        botones.forEach(function (b) {
          b.addEventListener('click', function () {
            var val = b.getAttribute('data-dv-val');
            var radios = [].slice.call(raiz.querySelectorAll(selRadio));
            var destino = radios.filter(function (r) { return r.getAttribute(atributo) === val; })[0];
            if (!destino || destino.disabled) return;
            destino.checked = true;
            destino.dispatchEvent(new Event('change', { bubbles: true }));
            marca();
          });
        });
        [].slice.call(raiz.querySelectorAll(selRadio)).forEach(function (r) {
          r.addEventListener('change', marca);
        });
        marca();
      }
      proxy('[data-dv-barra-pack-btn]', '[data-dv-pack]', 'data-dv-pack-val');
      proxy('[data-dv-barra-color]', '[data-dv-color]', 'value');

      // el boton reenvia el formulario real: conserva extras, unidades y cantidad
      if (boton && form) {
        boton.addEventListener('click', function () {
          if (boton.disabled) return;
          if (principal && principal.disabled) return;
          var previo = boton.textContent;
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-dv-texto-cargando') || 'Anadiendo';
          setTimeout(function () { boton.disabled = false; boton.textContent = previo; }, 6000);
          if (form.requestSubmit) { form.requestSubmit(principal || undefined); }
          else if (principal) { principal.click(); }
          else { form.submit(); }
        });
      }

      // visible solo tras pasar el boton de compra, y nunca sobre el cierre
      var ancla = principal || raiz;
      // Antes solo vigilaba el primer selector que existiera, asi que al llegar
      // al pie la barra seguia encima. Ahora mira todos los cierres.
      var cierres = [];
      ['.dv-cta', '.dv-footer', 'footer'].forEach(function (s) {
        var el = document.querySelector(s);
        if (el && cierres.indexOf(el) === -1) cierres.push(el);
      });

      function calcula() {
        var alto = window.innerHeight || document.documentElement.clientHeight || 800;
        var pasado = ancla ? ancla.getBoundingClientRect().bottom < 0 : true;
        var finVisible = cierres.some(function (el) {
          var r = el.getBoundingClientRect();
          return r.top < alto && r.bottom > 0;
        });
        barra.classList.toggle('dv-barra--ver', pasado && !finVisible);
      }

      var pendiente = false;
      function libera() { pendiente = false; calcula(); }
      function alMover() {
        if (pendiente) return;
        pendiente = true;
        // Con la pestana en segundo plano requestAnimationFrame no se ejecuta:
        // sin esta salida, `pendiente` se quedaba en true y la barra no volvia.
        if (document.hidden) { libera(); return; }
        window.requestAnimationFrame(libera);
      }
      window.addEventListener('scroll', alMover, { passive: true });
      window.addEventListener('resize', alMover);
      document.addEventListener('visibilitychange', libera);
      calcula();
    });
  }

  function initCarritoOpciones() {
    var cajas = document.querySelectorAll('[data-dv-copciones]');
    if (!cajas.length) return;
    [].slice.call(cajas).forEach(function (caja) {
      if (caja.getAttribute('data-dv-listo') === '1') return;
      caja.setAttribute('data-dv-listo', '1');

      [].slice.call(caja.querySelectorAll('[data-dv-copcion]')).forEach(function (fila) {
        var input = fila.querySelector('.dv-copcion__input');
        if (!input) return;

        input.addEventListener('change', function () {
          var marcado = input.checked;
          fila.classList.toggle('dv-copcion--si', marcado);
          caja.classList.add('dv-ocupado');

          var peticion;
          if (marcado) {
            peticion = fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(fila.getAttribute('data-dv-variante')), quantity: 1 }] })
            });
          } else {
            var clave = fila.getAttribute('data-dv-clave');
            if (!clave) { caja.classList.remove('dv-ocupado'); return; }
            peticion = fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: clave, quantity: 0 })
            });
          }

          peticion.then(function () { window.location.reload(); })
                  .catch(function () {
                    caja.classList.remove('dv-ocupado');
                    input.checked = !marcado;
                    fila.classList.toggle('dv-copcion--si', !marcado);
                  });
        });
      });
    });
  }


  // Selector de color conviviendo con las tarjetas de pack.
  // Al cambiar de color reescribe el value de cada radio de pack con la
  // variante correcta y relanza el evento para que initPacks haga el resto.
  function initColores() {
    var cajas = document.querySelectorAll('[data-dv-colores]');
    if (!cajas.length) return;
    cajas.forEach(function (caja) {
      if (caja.getAttribute('data-dv-listo') === '1') return;
      caja.setAttribute('data-dv-listo', '1');
      var raiz = caja.closest('[data-dv-producto]');
      if (!raiz) return;
      var datos = raiz.querySelector('[data-dv-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var etiqueta = caja.querySelector('[data-dv-color-nombre]');
      var radiosColor = caja.querySelectorAll('[data-dv-color]');
      var radiosPack = raiz.querySelectorAll('[data-dv-pack]');

      function buscaVariante(pack, color) {
        return variantes.filter(function (v) {
          return v.options[0] === pack && v.options[1] === color;
        })[0];
      }
      // Soporta los cuatro formatos de moneda de Shopify, no solo {{amount}}.
      function formatea(cent) {
        var f = raiz.getAttribute('data-dv-formato') || '{{amount}}';
        var n = cent / 100;
        function sep(valor, miles, dec, decimales) {
          var partes = valor.toFixed(decimales).split('.');
          partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
          return partes.length > 1 ? partes[0] + dec + partes[1] : partes[0];
        }
        return f
          .replace('{{amount_no_decimals_with_comma_separator}}', sep(n, '.', ',', 0))
          .replace('{{amount_with_comma_separator}}',             sep(n, '.', ',', 2))
          .replace('{{amount_no_decimals_with_space_separator}}', sep(n, ' ', ',', 0))
          .replace('{{amount_with_space_separator}}',             sep(n, ' ', ',', 2))
          .replace('{{amount_with_apostrophe_separator}}',        sep(n, "'", '.', 2))
          .replace('{{amount_no_decimals}}',                      sep(n, ',', '.', 0))
          .replace('{{amount}}',                                  sep(n, ',', '.', 2));
      }

      // Cambia la foto grande a la del color elegido.
      function pintaGaleria(idMedia) {
        if (!idMedia) return;
        var g = raiz.querySelector('[data-dv-galeria]');
        if (!g) return;
        var mini = g.querySelector('[data-dv-mini][data-dv-media="' + idMedia + '"]');
        if (!mini) return;
        var principal = g.querySelector('[data-dv-galeria-principal]');
        var src = mini.getAttribute('data-dv-src');
        if (principal && src && principal.getAttribute('src') !== src) {
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.setAttribute('src', src);
            var alt = mini.getAttribute('data-dv-alt');
            if (alt) principal.setAttribute('alt', alt);
            principal.style.opacity = '1';
          }, 120);
        }
        g.querySelectorAll('[data-dv-mini]').forEach(function (b) {
          b.classList.toggle('dv-activa', b === mini);
        });
      }

      function aplica(color) {
        if (etiqueta) etiqueta.textContent = color;
        var rc = caja.querySelector('[data-dv-color][value="' + color.replace(/"/g, '\\"') + '"]');
        if (rc) pintaGaleria(rc.getAttribute('data-dv-media'));
        caja.querySelectorAll('.dv-color').forEach(function (l) {
          var r = l.querySelector('[data-dv-color]');
          l.classList.toggle('dv-color--activo', !!(r && r.value === color));
        });
        var elegido = null;
        radiosPack.forEach(function (r) {
          var pack = r.getAttribute('data-dv-pack-val');
          var v = buscaVariante(pack, color);
          if (!v) { r.disabled = true; return; }
          r.disabled = false;
          r.value = v.id;
          r.setAttribute('data-dv-p', formatea(v.price));
          r.setAttribute('data-dv-a', v.compare_at_price > v.price ? formatea(v.compare_at_price) : '');
          var tarjeta = r.closest('[data-dv-caja]');
          if (tarjeta) {
            var pr = tarjeta.querySelector('.dv-oferta__precio');
            if (pr) pr.textContent = formatea(v.price);
            var un = tarjeta.querySelector('[data-dv-unidad]');
            if (un) {
              var n = parseInt(r.getAttribute('data-dv-u'), 10) || 1;
              un.textContent = formatea(Math.round(v.price / n)) + ' ' + (un.getAttribute('data-dv-unidad') || 'cada uno');
            }
          }
          if (r.checked) elegido = r;
        });
        if (elegido) elegido.dispatchEvent(new Event('change', { bubbles: true }));
      }

      radiosColor.forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) aplica(r.value); });
      });
      var inicial = caja.querySelector('[data-dv-color]:checked');
      if (inicial) aplica(inicial.value);
    });
  }

  function initVideos() {
    document.querySelectorAll('[data-dv-video]').forEach(function (caja) {
      if (yaHecho(caja, 'video-listo')) return;
      var v = caja.querySelector('video');
      var btn = caja.querySelector('.dv-video__play');
      if (!v) return;
      function alterna() {
        if (v.paused) {
          v.play();
          caja.classList.add('dv-reproduciendo');
        } else {
          v.pause();
          caja.classList.remove('dv-reproduciendo');
        }
      }
      if (btn) btn.addEventListener('click', alterna);
      v.addEventListener('click', alterna);
      v.addEventListener('pause', function () { caja.classList.remove('dv-reproduciendo'); });
    });
  }

  function initIrValoraciones() {
    document.querySelectorAll('[data-dv-ir-valoraciones]').forEach(function (a) {
      if (yaHecho(a, 'ir-val-listo')) return;
      var destino = document.getElementById('dv-valoraciones');
      if (!destino) {
        // No hay seccion de valoraciones en esta pagina: mejor sin enlace muerto.
        a.removeAttribute('href');
        a.setAttribute('data-dv-sin-destino', '1');
        return;
      }
      a.addEventListener('click', function (e) {
        e.preventDefault();
        destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        // Deja el ancla en la URL sin provocar un segundo salto.
        if (history && history.replaceState) history.replaceState(null, '', '#dv-valoraciones');
      });
    });
  }

  function init() {
    initReveals(); initEstrellas(); initCifras(); initFaq();
    initGaleria(); initVariantes(); initPacks(); initExtras(); initCantidad();
    initColores(); initBarra(); initCarritoOpciones(); initVideos(); initIrValoraciones();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
